import styled from 'styled-components';

import { staticCdnHost, MediaQueryBreakpoints } from '@rockalingua/ui';

const dropImagePath = `${staticCdnHost}/img/public-page/drop.svg`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  padding: 48px 0;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  margin-bottom: 48px;
  background-image: url('${dropImagePath}');
  background-repeat: no-repeat;
  background-position: right -60px center;
  background-size: min(600px, 46.875vw);
`;

export const TitleContainer = styled.div`
  padding: 0 48px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    padding: 0 24px;
  }
`;
